import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudOff2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloudOff2"><Path d="M18 20C20.7614 20 23 17.7614 23 15C23 12.5603 21.2527 10.5287 18.9412 10.0884C18.7634 8.72139 18.1912 7.4782 17.3425 6.47677L10.3877 20H18Z" fill="currentColor"/><Path d="M16.8466 3.06802L15.0681 2.15332L13.9732 4.28219C13.3466 4.0984 12.6842 3.99996 12 3.99996C9.14187 3.99996 6.68595 5.71237 5.59824 8.16481C2.96041 8.79647 1 11.1686 1 14C1 16.9513 3.13084 19.4049 5.93798 19.9063L5.15336 21.4319L6.93194 22.3466L16.8466 3.06802Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudOff2;
